import { render, staticRenderFns } from "./StarsPicker.vue?vue&type=template&id=28e7c7fe&scoped=true&"
import script from "./StarsPicker.vue?vue&type=script&lang=ts&"
export * from "./StarsPicker.vue?vue&type=script&lang=ts&"
import style0 from "./StarsPicker.vue?vue&type=style&index=0&id=28e7c7fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7c7fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
